export default __webpack_public_path__ + "static/media/2.76d99b18.jpeg";